module.exports = __webpack_public_path__ + "img/u1210.69d978df.svg";